// extracted by mini-css-extract-plugin
module.exports = {"PoemsHead":"GxxRg","PoemsPublications":"_1kAqZ","controlsBlock":"kyGjp"};